import React from 'react'

export default function Scroll({children}) {
  return (
    <div className='Scroll'>
        {children}
    </div>
  )
}
